<template>
  <div class="daidi-loading" v-show="isShow" @touchmove.prevent="daidiTouchmove">
    <img class="daidi-loading-pic" src="@/assets/global/daidi-loading.gif" alt="口袋故事">
    <div class="daidi-loading-text" :style="{ color: options.color, fontSize: options.fontSize }" v-html="text"></div>
  </div>
</template>

<script>
const defaultOptions = {
  color: '#6c6c73',
  fontSize: '18px',
}

export default {
  name: 'DaidiLoading',
  data () {
    return {
      isShow: false,
      text: '加载中...',
      options: defaultOptions,
    }
  },
  created () {
    // console.log(this.options)
  },
  methods: {
    daidiTouchmove () {
      // do nothing
    }
  }
}
</script>

<style lang="less" scoped>
  .daidi-loading {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(255,255,255,.9);
    z-index: 999;
    &-pic {
      width: 32%;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
    &-text {
      width: 100%;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
    }
  }
</style>
